import MyDialog from "~/mui/MyDialog";
import { useTrans } from "~/hooks/useTrans";
import { apiTransactionApprove } from "~/providers/api";
import { myUseState } from "~/hooks/myUseState";
import { ITransactionApproval } from "~/providers/interfaces";
import { useLang } from "~/hooks/useLang";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
}

interface IApproveTransactionModal {
	transaction: ITransactionApproval;
	onClose?: () => void;
	onSave?: () => void;
}

export default function ApproveTransactionModal({
	transaction,
	onClose = () => {},
	onSave = () => {},
}: IApproveTransactionModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const outputData = await apiTransactionApprove(transaction.transactionId, lang);

		if (outputData.noErrors) {
			onSave();
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: outputData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("approveTransactionModal.title")} onClose={onClose} onSave={dialogOnSave} dialogLoading={state.dialogLoading} errorMsg={state.errorMsg}
		cancelCaption={ trans("cancel") } saveCaption={ trans("approveTransactionModal.title") }
	>
		<p>
			{ trans("approveTransactionModal.desc") }
		</p>
	</MyDialog>;
}
